/**
 * Who owns an Escape while the sheet is full screen.
 *
 * A spreadsheet's Escape cancels the edit you are in the middle of — that is
 * the convention, and it is what AG Grid's own editors do. Leaving full screen
 * on the same keystroke would throw away the edit AND the layout at once, so
 * the shell only takes an Escape that nothing else wanted.
 *
 * `editingCellCount` comes from `GridApi.getEditingCells()`, which is non-empty
 * for the whole life of an open editor — including while its picker panel is
 * open in a body portal, where a `contains()` check on the shell would report
 * the click as outside.
 */
export const shouldExitFullscreen = (
  key: string,
  editingCellCount: number
): boolean => key === 'Escape' && editingCellCount === 0
